// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__e7qz2","inputWrap":"styles_inputWrap__39zee","input":"styles_input__1OvT_"};